<template>
    <div class="input-group mb-3">
      <div class="form-floating">
        <input
            @input="handleInput"
            type="text"
            class="form-control"
            :id="property"
            :value="value"
            :class="{'is-invalid': error }"
        >
        <label :for="property">{{ name }}<span class="text-danger" v-if="isRequired">*</span></label>
        <message-error :code="errorCode" :hasError="error"/>
      </div>
      <button
          class="btn btn-outline-secondary"
          type="button"
          :disabled="disabled"
          @click="clear"
      >Effacer</button>
    </div>
</template>

<script>
import MessageError from '@/core/components/MessageError.vue'

export default {
  name: 'TextButtonField',
  components: { MessageError },
  props:{
    value:{ type: String }, 
    property:{ type: String }, 
    name:{ type: String }, 
    error: {type: Boolean},
    disabled: {type: Boolean},
    isRequired: {type: Boolean},
    errorCode: { type: String }
  },
  methods:{
    handleInput(e){
      this.$emit('input',e.target.value)
    },
    clear(){
      this.$emit('input','')
    }
  }
}
</script>

<style scoped>

</style>
